import React from 'react';
import CategorySelect from 'COMPONENTS/breadcrumb/category-select/select';

const ParentCategoryIcon = ({ i18n, history, currentCategory, amount, isFetchingAmount, pp }) => <CategorySelect i18n={i18n} history={history} currentCategory={currentCategory} amount={amount} isFetchingAmount={isFetchingAmount} pp={pp} />;

export default ParentCategoryIcon;
